import { trans } from '@elements/translation';
import { initExpandableTextContent } from '../page-details/enableExpandableTextContent';

export default function () {
  if (!document.querySelector('.brand-details')) {
    return;
  }

  initExpandableTextContent({ expandLinkLabel: trans('brand_details.description.see_more') });

  const spaceCards = document.querySelectorAll('.brand-details__space');

  spaceCards.forEach((spaceCard) => {
    let { id } = spaceCard.querySelector('article');
    // Remove suffix page-space-{id}
    id = id.slice(11);

    const markerId = `marker-space-${id}`;

    spaceCard.addEventListener('mouseenter', () => {
      document.getElementById(markerId)?.classList.add('hover');
    });
    spaceCard.addEventListener('mouseleave', () => {
      document.getElementById(markerId)?.classList.remove('hover');
    });
  });
}
